import React from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';

import { ModalMessage } from './styled';

export const AcceptModalBody: React.FC<{
  onConfirm: () => void;
  onDismiss: () => void;
  pickupTime?: string;
  onDecline?: () => void;
}> = ({ onConfirm, pickupTime = '' }) => {
  const { formatMessage, formatTime, formatDate } = useIntl();
  const pickupTimeString = formatTime(new Date(pickupTime), {
    format: 'h:mm a',
  });
  const pickupDateString = formatDate(pickupTime, {
    format: 'MMMM dd, yyyy',
  });
  return (
    <>
      <ModalMessage>
        {formatMessage(
          { id: 'acceptOrderModal' },
          {
            date: pickupDateString,
            time: pickupTimeString,
            serviceMode: 'pickup',
          }
        )}
      </ModalMessage>
      <Box position="absolute" bottom="50px">
        <ActionButton onClick={onConfirm}>{formatMessage({ id: 'accept' })}</ActionButton>
      </Box>
    </>
  );
};
